import React from 'react';
import { Box } from '@mui/material';

interface POSTagProps {
  pos?: string | null;
}

const POSTag: React.FC<POSTagProps> = ({ pos }) => {
  if (!pos) return null;
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'primary.tableBorder',
        borderRadius: '5px',
        color: 'text.secondary',
        fontSize: 11,
        fontWeight: 700,
        px: 0.75,
        py: '1px',
        textTransform: 'lowercase',
        whiteSpace: 'nowrap',
      }}
    >
      {pos}
    </Box>
  );
};

export default POSTag;
